import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "error-page" };
const _hoisted_2 = { class: "error-page__error" };
const _hoisted_3 = { href: "/programs" };
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("h1", { class: "error-page__title" }, "Oops!", -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("h2", { class: "error-page__message" }, " Looks like this page is not what you were expecting. ", -1 /* HOISTED */);
import extoleLogo from "assets/extole-logomark.svg";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Error404Page',
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("a", _hoisted_3, [
                        _createElementVNode("img", {
                            class: "error-page__logomark",
                            src: _unref(extoleLogo)
                        }, null, 8 /* PROPS */, _hoisted_4)
                    ]),
                    _hoisted_5,
                    _hoisted_6
                ])
            ]));
        };
    }
});
